import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material';

const DSChip = (props: React.ComponentProps<typeof Chip>) => {
  const { palette, spacing } = useTheme();

  return (
    <Chip
      {...props}
      sx={{
        backgroundColor: palette.primary.main,
        color: palette.primary.contrastText,
        fontFamily: 'Gilroy-SemiBold',
        fontSize: '13px',
        fontWeight: 400,
        lineHeight: '18px',
        letterSpacing: '0.16px',
        padding: spacing(1.25),
        borderRadius: spacing(3),
        height: 'auto',
        ...props.sx,
      }}
    />
  );
};

export default DSChip;
